import { Component, ViewChild } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { of as RxOf } from 'rxjs/observable/of';
import { defer as _defer, cloneDeep as _cloneDeep } from 'lodash';

import {
  AbstractBlModal,
  ModalReason,
  BlRadioGroupComponent
} from '@blcloud/bl-ng-ui-component';

import {
  ICustomerVehicleSearchScreenActionSetting,
  CustomerRankColorDivArray,
  CustomerRankColorDiv
} from './customer-vehicle-search-screen-action-setting-modal.define';
import { IServiceContractStatus } from '../../page/customer-vehicle-search-page/customer-vehicle-search-page.interface';

@Component({
  templateUrl: './customer-vehicle-search-screen-action-setting-modal.component.html',
  styleUrls: ['./customer-vehicle-search-screen-action-setting-modal.component.scss']
})
export class CustomerVehicleSearchScreenActionSettingModalComponent extends AbstractBlModal {

  /** 画面動作設定 */
  _screenActionSetting: ICustomerVehicleSearchScreenActionSetting;

  /** 初期表示タブ項目リスト */
  _customerRankColorItems = CustomerRankColorDivArray.map(
    item => {
      return { code: item.value, name: item.text };
    }
  );

  /** 初期カーソル項目入力コンポーネント */
  @ViewChild('customerRankColor') private customerRankColor: BlRadioGroupComponent;

  /** サービス有効フラグ */
  _isAvailableService: IServiceContractStatus;

  /** ヘッダ部テキスト */
  availableVehicleCustomer = '';

  /** コンテンツ部テキスト */
  availableVehicleCustomerRankColor = '';

  constructor(
  ) {
    super();
  }

  /**
   * @override
   */
  getResults(): any {
    return this._screenActionSetting;
  }

  /**
   * @override
   */
  onShown() {
    this._screenActionSetting = _cloneDeep(this.data.screenActionSetting);
    this._isAvailableService = _cloneDeep(this.data.isAvailableService);

    const customerRankSingle = this._isAvailableService.customerRank && !this._isAvailableService.vehicleRank;
    const vehicleRankSingle = !this._isAvailableService.customerRank && this._isAvailableService.vehicleRank;
    if (customerRankSingle) {
      this.availableVehicleCustomer = this.availableVehicleCustomerRankColor = '顧客';
    } else if (vehicleRankSingle) {
      this.availableVehicleCustomer = this.availableVehicleCustomerRankColor = '車両';
    } else {
      this.availableVehicleCustomer = '顧客・車両';
    }

    this._customerRankColorItems.forEach(
      item => {
        if (item.code === CustomerRankColorDiv.ReflectInName) {
          const customerOnlyName = 'お客様名、フリガナに反映する';
          const vehicleOnlyName = '車両登録番号に反映する';
          item.name = customerRankSingle ? customerOnlyName : vehicleRankSingle ? vehicleOnlyName : item.name;
        }
      }
    );
    // 初期フォーカス
    _defer(() => {
      if (this.customerRankColor) {
        this.customerRankColor.focus();
      }
    });
  }

  /**
   * @override
   */
  dismiss(reason: ModalReason) {
    if (reason === ModalReason.Done) {
      this.validate().subscribe(
        result => {
          if (result) {
            this.emitDismissEvent(reason);
          }
        }
      );
    } else {
      // 確定以外はそのまま通知
      this.emitDismissEvent(reason);
    }
  }

  // ================================================================
  // private

  /**
   * 入力検証します。
   * @returns 検証結果
   */
  private validate(): Observable<boolean> {
    return RxOf(true);
  }
}



// WEBPACK FOOTER //
// ./src/app/feature/customer-vehicle-search-screen-action-setting-modal/customer-vehicle-search-screen-action-setting-modal.component.ts